import { apiCall } from "../../../_utils";
import { apiUrls } from "../../../_constants";

export const institutionService = {
  getAllInstitutions,
  addInstitution,
  getInstitution
};

function getAllInstitutions() {
  return apiCall("GET", apiUrls.institutions.base);
}

function addInstitution(request) {
  const method = request && request.id ? "PUT" : "POST";
  return apiCall(method, apiUrls.institutions.base, request);
}

function getInstitution(id) {
  return apiCall("GET", `${apiUrls.institutions.base}/${id}`);
}
